import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  desfoque: false,
  modalLogin: 'fechado',
  modalArquivo: 'fechado',
  modalServico: 'fechado',
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    resetarModais(state) {
      state.modalLogin = 'fechado';
      state.modalLoginTotem = 'fechado';
      state.modalEscolhaLoginTotem = 'fechado';
      state.modalArquivo = 'fechado';
      state.modalAjuda = 'fechado';
      state.modalImpressao = 'fechado';
      state.modalImpressaoSic = 'fechado';
      state.modalImpressaoZeladoria = 'fechado';
      state.modalBairro = 'fechado';
      state.modalEnquete = 'fechado';
      state.modalContato = 'fechado';
      state.modalServico = 'fechado';
      state.modalCategoria = 'fechado';
      state.modalUnidade = 'fechado';
      state.modalAssunto = 'fechado';
      state.modalProtocolo = 'fechado';
      state.modalSexo = 'fechado';
      state.modalEscolaridade = 'fechado';
      state.modalComoSoube = 'fechado';
      state.modalAnonimo = 'fechado';
      state.desfoque = false;
    },
    abrirModalLogin(state) {
      state.modalLogin = 'aberto';
      state.desfoque = true;
      state.origem = '';
    },
    abrirModalLoginManifestacao(state, action) {
      state.modalLogin = 'aberto';
      state.desfoque = true;
      state.origem = 'manifestacao';
      state.secretaria = action.payload;
    },
    abrirModalLoginSic(state, action) {
      state.modalLogin = 'aberto';
      state.desfoque = true;
      state.origem = 'sic';
      state.secretaria = action.payload;
    },
    abrirModalLoginZeladoria(state, action) {
      state.modalLogin = 'aberto';
      state.desfoque = true;
      state.origem = 'zeladoria';
      state.secretaria = action.payload;
    },
    fecharModalLogin(state) {
      state.modalLogin = 'fechado';
      state.desfoque = false;
    },
    abrirModalEscolhaLoginTotem(state) {
      state.modalEscolhaLoginTotem = 'aberto';
      state.desfoque = true;
      state.origem = '';
    },
    fecharModalEscolhaLoginTotem(state) {
      state.modalEscolhaLoginTotem = 'fechado';
      state.desfoque = false;
    },
    abrirModalTotemEscolhaLoginManifestacao(state, action) {
      state.modalEscolhaLoginTotem = 'aberto';
      state.desfoque = true;
      state.origem = 'manifestacao';
      state.secretaria = action.payload;
    },
    abrirModalTotemEscolhaLoginSic(state, action) {
      state.modalEscolhaLoginTotem = 'aberto';
      state.desfoque = true;
      state.origem = 'sic';
      state.secretaria = action.payload;
    },
    abrirModalTotemEscolhaLoginZeladoria(state, action) {
      state.modalEscolhaLoginTotem = 'aberto';
      state.desfoque = true;
      state.origem = 'zeladoria';
      state.secretaria = action.payload;
    },
    abrirModalTotemLogin(state) {
      state.modalLoginTotem = 'aberto';
      state.desfoque = true;
      state.origem = '';
    },
    fecharModalTotemLogin(state) {
      state.modalLoginTotem = 'fechado';
      state.desfoque = false;
    },
    abrirModalTotemLoginManifestacao(state, action) {
      state.modalLoginTotem = 'aberto';
      state.desfoque = true;
      state.origem = 'manifestacao';
      state.secretaria = action.payload;
    },
    abrirModalTotemLoginSic(state, action) {
      state.modalLoginTotem = 'aberto';
      state.desfoque = true;
      state.origem = 'sic';
      state.secretaria = action.payload;
    },
    abrirModalTotemLoginZeladoria(state, action) {
      state.modalLoginTotem = 'aberto';
      state.desfoque = true;
      state.origem = 'zeladoria';
      state.secretaria = action.payload;
    },
    abrirModalArquivo(state) {
      state.modalArquivo = 'aberto';
      state.desfoque = true;
    },
    fecharModalArquivo(state) {
      state.modalArquivo = 'fechado';
      state.desfoque = false;
    },
    abrirModalAjuda(state) {
      state.modalAjuda = 'aberto';
      state.desfoque = true;
    },
    fecharModalAjuda(state) {
      state.modalAjuda = 'fechado';
      state.desfoque = false;
    },
    abrirModalBairro(state, action) {
      state.modalBairro = 'aberto';
      state.desfoque = true;
      state.bairros = action.payload;
    },
    fecharModalBairro(state) {
      state.modalBairro = 'fechado';
      state.desfoque = false;
    },
    abrirModalAssunto(state, action) {
      state.modalAssunto = 'aberto';
      state.desfoque = true;
      state.assuntos = action.payload;
    },
    fecharModalAssunto(state) {
      state.modalAssunto = 'fechado';
      state.desfoque = false;
    },
    abrirModalSexo(state, action) {
      state.modalSexo = 'aberto';
      state.desfoque = true;
      state.sexo = action.payload;
    },
    fecharModalSexo(state) {
      state.modalSexo = 'fechado';
      state.desfoque = false;
    },

    abrirModalEscolaridade(state, action) {
      state.modalEscolaridade = 'aberto';
      state.desfoque = true;
      state.escolaridade = action.payload;
    },
    fecharModalEscolaridade(state) {
      state.modalEscolaridade = 'fechado';
      state.desfoque = false;
    },

    abrirModalComoSoube(state, action) {
      state.modalComoSoube = 'aberto';
      state.desfoque = true;
      state.comoSoube = action.payload;
    },
    fecharModalComoSoube(state) {
      state.modalComoSoube = 'fechado';
      state.desfoque = false;
    },

    abrirModalProtocolo(state, action) {
      state.modalProtocolo = 'aberto';
      state.desfoque = true;
      state.protocolo = action.payload;
      state.origem = 'manifestacao';
    },
    abrirModalProtocoloSic(state, action) {
      state.modalProtocolo = 'aberto';
      state.desfoque = true;
      state.protocolo = action.payload;
      state.origem = 'sic';
    },
    abrirModalProtocoloZeladoria(state, action) {
      state.modalProtocolo = 'aberto';
      state.desfoque = true;
      state.protocolo = action.payload;
      state.origem = 'zeladoria';
    },
    fecharModalProtocolo(state) {
      state.modalProtocolo = 'fechado';
      state.desfoque = false;
    },
    abrirModalCategoria(state, action) {
      state.modalCategoria = 'aberto';
      state.desfoque = true;
      state.categorias = action.payload;
    },
    fecharModalCategoria(state) {
      state.modalCategoria = 'fechado';
      state.desfoque = false;
    },
    abrirModalUnidade(state, action) {
      state.modalUnidade = 'aberto';
      state.desfoque = true;
      state.unidades = action.payload;
    },
    fecharModalUnidade(state) {
      state.modalUnidade = 'fechado';
      state.desfoque = false;
    },
    abrirModalImpressao(state, action) {
      state.modalImpressao = 'aberto';
      state.dados = action.payload;
      state.desfoque = true;
    },
    abrirModalImpressaoSic(state, action) {
      state.modalImpressaoSic = 'aberto';
      state.dados = action.payload;
      state.desfoque = true;
    },
    abrirModalImpressaoZeladoria(state, action) {
      state.modalImpressaoZeladoria = 'aberto';
      state.dados = action.payload;
      state.desfoque = true;
    },
    fecharModalImpressao(state) {
      state.modalImpressao = 'fechado';
      state.desfoque = false;
    },
    fecharModalImpressaoSic(state) {
      state.modalImpressaoSic = 'fechado';
      state.desfoque = false;
    },
    fecharModalImpressaoZeladoria(state) {
      state.modalImpressaoZeladoria = 'fechado';
      state.desfoque = false;
    },
    abrirModalEnquete(state) {
      state.modalEnquete = 'aberto';
      state.desfoque = true;
    },
    fecharModalEnquete(state) {
      state.modalEnquete = 'fechado';
      state.desfoque = false;
    },
    abrirModalContato(state) {
      state.modalContato = 'aberto';
      state.desfoque = true;
    },
    fecharModalContato(state) {
      state.modalContato = 'fechado';
      state.desfoque = false;
    },
    abrirModalServico(state) {
      state.modalServico = 'aberto';
      state.desfoque = true;
    },
    fecharModalServico(state) {
      state.modalServico = 'fechado';
      state.desfoque = false;
    },
    abrirModalAnonimo(state) {
      state.modalAnonimo = 'aberto';
      state.desfoque = true;
    },
    fecharModalAnonimo(state) {
      state.modalAnonimo = 'fechado';
      state.desfoque = false;
    },
  },
});

export const selectModal = (state) => state.modal;

export const {
  abrirModalLogin, abrirModalLoginManifestacao, abrirModalLoginSic, abrirModalLoginZeladoria,
  abrirModalArquivo, fecharModalLogin, fecharModalArquivo, abrirModalAjuda, abrirModalAssunto, fecharModalAssunto, abrirModalCategoria, fecharModalCategoria,
  fecharModalAjuda, abrirModalBairro, fecharModalBairro, abrirModalImpressao, fecharModalImpressao, resetarModais, abrirModalUnidade, fecharModalUnidade,
  abrirModalEnquete, fecharModalEnquete, abrirModalContato, fecharModalContato, abrirModalProtocolo, fecharModalProtocolo, abrirModalTotemLogin, fecharModalTotemLogin,
  abrirModalImpressaoSic, fecharModalImpressaoSic, abrirModalImpressaoZeladoria, fecharModalImpressaoZeladoria, abrirModalServico, fecharModalServico,
  abrirModalTotemLoginManifestacao, abrirModalTotemLoginSic, abrirModalEscolhaLoginTotem, fecharModalEscolhaLoginTotem, abrirModalTotemEscolhaLoginManifestacao,
  abrirModalTotemEscolhaLoginSic, abrirModalTotemEscolhaLoginZeladoria, abrirModalSexo, fecharModalSexo, abrirModalEscolaridade, fecharModalEscolaridade,
  abrirModalComoSoube, fecharModalComoSoube, abrirModalProtocoloSic, abrirModalProtocoloZeladoria, abrirModalAnonimo, fecharModalAnonimo,
} = modalSlice.actions;

export default modalSlice.reducer;
